(() => {
  if (!('IntersectionObserver' in window)) {
    // No observer support: reveal immediately so bars always show.
    document.querySelectorAll('value-comparison').forEach((el) => el.classList.add('is-visible'));
    return;
  }

  class ValueComparison extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25 }
      );
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!customElements.get('value-comparison')) {
    customElements.define('value-comparison', ValueComparison);
  }
})();
